<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Usuário Cadastrados'">
          <template v-slot:preview>
            <div col-md-2 col-lg-2>
              <v-btn
                v-if="verificarPermissao(1)"
                color="primary"
                fab
                small
                dark
                @click="novoUsuario"
                ><v-icon>mdi-plus</v-icon></v-btn
              >
            </div>
            <br />
            <v-tabs>
              <v-tab>Meus Usuários</v-tab>
              <v-tab>Usuários das Empresas</v-tab>
              <v-tab-item>
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nome</th>
                      <th>Perfil</th>
                      <th>Email</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(usuario, index) in usuarios" :key="usuario.id">
                      <td>{{ usuario.id }}</td>
                      <td>{{ usuario.nome }}</td>
                      <td>{{ usuario.perfil.nome }}</td>
                      <td>{{ usuario.logins[0].email }}</td>
                      <td align="center">
                        <span class="text-success" v-if="usuario.ativo"
                          >Ativo</span
                        >
                        <span class="text-danger" v-else>Inativo</span>
                      </td>
                      <td style="width: 15%">
                        <div v-if="usuario.ativo">
                          <v-btn
                            :disabled="!verificarPermissao(2)"
                            color="warning"
                            fab
                            x-small
                            dark
                            title="Editar Usuário"
                            @click="editar(usuario.id)"
                            ><v-icon>mdi-pencil</v-icon></v-btn
                          >&nbsp;
                          <v-btn
                            :disabled="!verificarPermissao(3)"
                            color="error"
                            fab
                            x-small
                            dark
                            title="Inativar Usuário"
                            @click="inativar(usuario.id, index, usuarios)"
                            ><v-icon>mdi-trash-can</v-icon></v-btn
                          >&nbsp;
                          <v-btn
                            :disabled="!verificarPermissao(2)"
                            color="cyan"
                            fab
                            x-small
                            dark
                            title="Resetar Senha"
                            @click="reiniciarSenha(usuario)"
                            ><v-icon small>fab fa-telegram-plane</v-icon></v-btn
                          >
                        </div>
                        <div v-else>
                          <v-btn
                            :disabled="!verificarPermissao(2)"
                            color="secondary"
                            fab
                            x-small
                            dark
                            ><v-icon>mdi-pencil</v-icon></v-btn
                          >&nbsp;
                          <v-btn
                            color="secondary"
                            :disabled="!verificarPermissao(3)"
                            fab
                            x-small
                            dark
                            ><v-icon>mdi-trash-can</v-icon></v-btn
                          >&nbsp;
                          <v-btn color="secondary" fab x-small dark
                            ><v-icon small>fab fa-telegram-plane</v-icon></v-btn
                          >&nbsp;
                          <v-btn
                            color="success"
                            fab
                            x-small
                            dark
                            :disabled="!verificarPermissao(2)"
                            title="Reativar Usuário"
                            @click="reativar(usuario.id, index, usuarios)"
                            ><v-icon small>fas fa-lock-open</v-icon></v-btn
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-tab-item>
              <v-tab-item>
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Empresa</th>
                      <th>Nome</th>
                      <th>Perfil</th>
                      <th>Email</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(usuario, index) in usuariosEmpresas"
                      :key="usuario.id"
                    >
                      <td>{{ usuario.id }}</td>
                      <td>{{ nomeEmpresa(usuario.empresasID) }}</td>
                      <td>{{ usuario.nome }}</td>
                      <td>Empresa</td>
                      <td>{{ usuario.email }}</td>
                      <td align="center">
                        <span class="text-success" v-if="usuario.ativo"
                          >Ativo</span
                        >
                        <span class="text-danger" v-else>Inativo</span>
                      </td>
                      <td style="width: 15%">
                        <div v-if="usuario.ativo">
                          <v-btn
                            color="warning"
                            fab
                            x-small
                            dark
                            title="Editar Senha"
                            @click="editar(usuario.id)"
                            :disabled="!verificarPermissao(2)"
                            ><v-icon>mdi-pencil</v-icon></v-btn
                          >&nbsp;
                          <v-btn
                            color="error"
                            fab
                            x-small
                            dark
                            title="Inativar Usuário"
                            :disabled="!verificarPermissao(3)"
                            @click="
                              inativar(usuario.id, index, usuariosEmpresas)
                            "
                            ><v-icon>mdi-trash-can</v-icon></v-btn
                          >&nbsp;
                          <v-btn
                            color="cyan"
                            fab
                            x-small
                            dark
                            title="Resetar Senha"
                            @click="reiniciarSenha(usuario)"
                            :disabled="!verificarPermissao(2)"
                            ><v-icon small>fab fa-telegram-plane</v-icon></v-btn
                          >
                        </div>
                        <div v-else>
                          <v-btn
                            color="secondary"
                            fab
                            x-small
                            :disabled="!verificarPermissao(2)"
                            dark
                            title="Editar Usuário"
                            ><v-icon>mdi-pencil</v-icon></v-btn
                          >&nbsp;
                          <v-btn
                            color="secondary"
                            fab
                            :disabled="!verificarPermissao(3)"
                            x-small
                            dark
                            title="Inativar Usuário"
                            ><v-icon>mdi-trash-can</v-icon></v-btn
                          >&nbsp;
                          <v-btn
                            :disabled="!verificarPermissao(2)"
                            color="secondary"
                            fab
                            x-small
                            dark
                            title="Resetar Senha"
                            ><v-icon small>fab fa-telegram-plane</v-icon></v-btn
                          >&nbsp;
                          <v-btn
                            :disabled="!verificarPermissao(2)"
                            color="success"
                            fab
                            x-small
                            dark
                            title="Reativar Usuário"
                            @click="
                              reativar(usuario.id, index, usuariosEmpresas)
                            "
                            ><v-icon small>fas fa-lock-open</v-icon></v-btn
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-tab-item>
            </v-tabs>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import { SET_LOADING } from "@/store/config.module";

export default {
  name: "usuario",
  data() {
    return {
      usuarios: [],
      usuariosEmpresas: [],
      empresas: [],
      permissoesPadrao: {},
      cliente: {},
    };
  },
  components: {
    KTCodePreview,
  },
  methods: {
    novoUsuario() {
      this.popularPaginacaoUsuarios();
      this.popularPaginacaoUsuarioEmpresa();
      this.$router.push({ name: "usuarioCadastro" });
    },

    listaUsuarios() {
      return new Promise((resolve) => {
        ApiService.get("usuario/getbyclienteid/" + this.cliente.id).then(
          ({ data }) => {
            resolve(data);

            // const tabelaUsuario = sessionStorage.getItem("tabelaUsuario") ? JSON.parse(sessionStorage.getItem("tabelaUsuario")) : null;

            // if(tabelaUsuario){
            //   this.itemsPerPage = tabelaUsuario.itemsPerPage;
            //   this.page = tabelaUsuario.page;
            // }

            // sessionStorage.removeItem("tabelaUsuario");

            if (data.success) this.usuarios = data.data;
            else SweetAlert.sweetAlertError(data.errors);

            this.$store.commit(SET_LOADING, false);
          }
        );
      });
    },

    listaUsuariosEmpresas() {
      return new Promise((resolve) => {
        ApiService.get(
          "usuario/getusuarioempresabyclienteid/" + this.cliente.id
        ).then(({ data }) => {
          resolve(data);

          // const tabelaUsuarioEmpresa = sessionStorage.getItem("tabelaUsuarioEmpresa") ? JSON.parse(sessionStorage.getItem("tabelaUsuarioEmpresa")) : null;

          // if(tabelaUsuarioEmpresa){
          //   this.itemsPerPage = tabelaUsuarioEmpresa.itemsPerPage;
          //   this.page = tabelaUsuarioEmpresa.page;
          // }

          // sessionStorage.removeItem("tabelaUsuarioEmpresa");

          if (!data.success) {
            return SweetAlert.sweetAlertError(data.errors);
          }

          this.usuariosEmpresas = data.data;
        });
      });
    },

    listaEmpresas() {
      return new Promise((resolve) => {
        ApiService.get("empresa/getbyclienteid/" + this.cliente.id).then(
          ({ data }) => {
            if (data.success) {
              resolve(data);
              this.empresas = data.data;
              this.listaUsuariosEmpresas();
            } else {
              SweetAlert.sweetAlertError(data.errors);
            }
          }
        );
      });
    },

    editar(id) {
      this.popularPaginacaoUsuarios();
      this.popularPaginacaoUsuarioEmpresa();
      this.$router.push({ path: "usuario/cadastro/" + id });
    },

    inativar(id, index, lista) {
      Swal.fire({
        title: "Tem certeza que deseja excluir esse registro?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode excluir!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("usuario/inativar/" + id).then(({ data }) => {
              resolve(data);

              if (data.success === true) {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Usuário Inativado com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  lista[index].ativo = false;
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          });
        }
      });
    },

    popularPaginacaoUsuarios() {
      //TODO: Ainda não possui v-datatable nessa pagina
      // const tabelaUsuario = {
      //   page: this.page,
      //   itemsPerPage: this.itemsPerPage
      // }
      // sessionStorage.setItem('tabelaUsuario', JSON.stringify(tabelaUsuario));
    },

    popularPaginacaoUsuarioEmpresa() {
      //TODO: Ainda não possui v-datatable nessa pagina
      // const tabelaUsuarioEmpresa = {
      //   page: this.page,
      //   itemsPerPage: this.itemsPerPage
      // }
      // sessionStorage.setItem('tabelaUsuarioEmpresa', JSON.stringify(tabelaUsuarioEmpresa));
    },

    reativar(id, index, lista) {
      Swal.fire({
        title: "Tem certeza que deseja reativar esse usuário?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode reativar!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("usuario/ativar/" + id).then(({ data }) => {
              resolve(data);

              if (data.success === true) {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Usuário Reativado com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  lista[index].ativo = true;
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          });
        }
      });
    },

    async reiniciarSenha(usuario) {
      let self = this;

      let email =
        usuario.logins != null && usuario.logins.length > 0
          ? usuario.logins[0].email
          : usuario.email;

      Swal.fire({
        title: "Reinicio de Senha",
        text:
          "Tem certeza que deseja reiniciar a senha do usuário " +
          usuario.nome +
          "? Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode reiniciar!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("usuario/updatepassword", {
              email: email,
            }).then(({ data }) => {
              resolve(data);

              self.dialog = false;

              if (data.success)
                SweetAlert.sweetAlertSuccess(
                  "Solicitação de Nova Senha Realizada com Sucesso!<br>Um E-mail foi encaminhado com os novos dados de acesso.",
                  5000
                );
              else SweetAlert.sweetAlertError(data.errors);
            });
          });
        }
      });
    },
    verificarPermissao(permissao) {
      return PermissoesService.verificarAcesso(Modulo.Usuario, permissao);
    },
    nomeEmpresa(empresasID) {
      if(empresasID.length > 1)
        return "Múltiplas Empresas";
      else
        return this.empresas.find((x) => x.id === empresasID[0]).nome;     
    },
  },
  mounted() {
    this.$store.dispatch(SET_LOADING, true);
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.permissoesPadrao = Permissoes;
    this.listaUsuarios();
    this.listaEmpresas();
  },
  created() {
    if (
      !PermissoesService.verificarAcesso(Modulo.Usuario, Permissoes.Visualizar)
    ) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
